import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import MasterDashboard from "@/pages/MasterDashboard";
import Jobs from "@/pages/Jobs";
import JobApplications from "@/pages/JobApplications";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";
import Careers from "@/pages/Careers";
import Apply from "@/pages/Apply";
import Branding from "@/pages/Branding";
import EmbedCareers from "@/pages/EmbedCareers";
import EmbedJob from "@/pages/EmbedJob";

function RootRedirect() {
  const { status, user } = useAuth();
  if (status === "loading")
    return <div className="min-h-screen flex items-center justify-center text-[#86868B]">Loading…</div>;
  if (status === "guest") return <Navigate to="/login" replace />;
  if (user.role === "master_admin") return <Navigate to="/master" replace />;
  return <Navigate to="/jobs" replace />;
}

function Protected({ roles, children }) {
  const { status, user } = useAuth();
  if (status === "loading")
    return <div className="min-h-screen flex items-center justify-center text-[#86868B]">Loading…</div>;
  if (status === "guest") return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" richColors offset={16} />
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/careers/:slug" element={<Careers />} />
            <Route path="/apply/:jobId" element={<Apply />} />
            <Route path="/embed/careers/:slug" element={<EmbedCareers />} />
            <Route path="/embed/job/:jobId" element={<EmbedJob />} />
            <Route path="/master" element={<Protected roles={["master_admin"]}><MasterDashboard /></Protected>} />
            <Route path="/jobs" element={<Protected roles={["tenant_admin", "hr_member"]}><Jobs /></Protected>} />
            <Route path="/jobs/:jobId" element={<Protected roles={["tenant_admin", "hr_member"]}><JobApplications /></Protected>} />
            <Route path="/team" element={<Protected roles={["tenant_admin", "hr_member"]}><Team /></Protected>} />
            <Route path="/settings" element={<Protected roles={["tenant_admin", "hr_member"]}><Settings /></Protected>} />
            <Route path="/branding" element={<Protected roles={["tenant_admin", "hr_member"]}><Branding /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
